import { FC, HTMLAttributes } from "react";
import map from "lodash-es/map";
import clsx from "classnames";
import { useStyles } from "./GamesSection.style";
import { getGameImage } from "../../../models/game";
import Gems from "../../../assets/leaderboard/gems.webp";
import Gems2x from "../../../assets/leaderboard/gems@2x.webp";
import Gems3x from "../../../assets/leaderboard/gems@3x.webp";
import Label from "../../../assets/gems/label.webp";
import Label2x from "../../../assets/gems/label@2x.webp";
import Label3x from "../../../assets/gems/label@3x.webp";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import { Game } from "@onmo/graphql/graphql";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";

interface IGamesSection {
  games: Game[];
  isTopGame?: boolean;
  isEndscreen?: boolean;
  onCloseEndscreen?: () => void;
}
export const GamesSection: FC<
  IGamesSection & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { games, isTopGame, isEndscreen, onCloseEndscreen } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const { gameId } = useParams<{ gameId: string }>();

  const location = useLocation();
  const isGuestPage = location.pathname === PageRoutes.Guest;

  const handleNavigatePlayGame = (gameId: string) => {
    isEndscreen && onCloseEndscreen?.();
    navigate(`${PageRoutes.Play}/${gameId}`, { replace: true });
  };

  return (
    <div className={classes.content}>
      {map(games, (game, idx) => {
        if (gameId === game.id && isEndscreen) return null;
        const { webp, webp2x, webp3x } = getGameImage("small", game);
        return (
          <div
            className={clsx(classes.card, isEndscreen && "endscreen")}
            key={idx}
            onClick={() => !isGuestPage && handleNavigatePlayGame(game.id)}
          >
            <div className={classes.layer} />
            <Image
              src={webp || ""}
              src2x={webp2x}
              src3x={webp3x}
              className={classes.gameImg}
            />
            {isTopGame && (
              <div className={classes.rank}>
                <Image src={Label} src2x={Label2x} src3x={Label3x} />
                <Typography
                  variant={TypographyVariant.BodyB4Bold}
                  className={classes.rankText}
                >
                  {idx + 1}
                </Typography>
              </div>
            )}
            <div className={classes.gems}>
              <Image
                src={Gems}
                src2x={Gems2x}
                src3x={Gems3x}
                className={classes.gemImg}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GamesSection;
